import { useRef, useState } from "react";

export default function useSurveyLifecycle({ onPublish, onInactivate, onDelete }) {
  const busyRef = useRef(false);
  const [confirmation, setConfirmation] = useState(null);

  const confirmAction = async () => {
    if (!confirmation || busyRef.current) return;
    busyRef.current = true;
    try {
      if (confirmation.action === "publish") await onPublish();
      else if (confirmation.action === "inactivate") await onInactivate();
      else if (confirmation.action === "delete") await onDelete();
    } finally {
      busyRef.current = false;
    }
  };

  return { confirmation, setConfirmation, confirmAction };
}
